import { jsx as _jsx } from "react/jsx-runtime";
import { area, curveMonotoneX } from 'd3-shape';
import { StyledPath } from './styles';
export var AreaLayer = function (_a) {
  var _b;
  var series = _a.series,
    xScale = _a.xScale,
    yScale = _a.yScale,
    innerHeight = _a.innerHeight;
  var areaGenerator = area().x(function (d) {
    return xScale(d.data.x);
  }).y0(innerHeight).y1(function (d) {
    return yScale(d.data.y);
  }).curve(curveMonotoneX);
  var mainSeries = series.find(function (s) {
    return !s.isAdditional;
  });
  if (!mainSeries) {
    return null;
  }
  return _jsx(StyledPath, {
    d: (_b = areaGenerator(mainSeries.data)) !== null && _b !== void 0 ? _b : ''
  });
};